import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.RacecarImageSelect.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.RacecarImageSelect.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.question = [];
  this.answers = [];
  this.correctAnswers = 0;
};

EDC.Games.RacecarImageSelect.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.RacecarImageSelect.Scenes.Main.prototype.constructor = EDC.Games.RacecarImageSelect.Scenes.Main;

const RIS = EDC.Games.RacecarImageSelect.Scenes.Main.prototype;

RIS.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

RIS.createTemplateUI = function () {
  const title = this.add.sprite(310, 250, 'title');
  const instructions = this.add.sprite(320, 860, 'instructions').setOrigin(0.5);
  const flag = this.add.sprite(1100, 400, 'flag');
};

RIS.loadIteration = function () {
  this.createQuestion();
  this.createCars();
};

RIS.createCars = function () {
  const { images } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { correct } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const answer = {
    0: {
      x: 1460, y: 660, sprite: 'car-3', textY: 20,
    },
    1: {
      x: 1680, y: 870, sprite: 'car-4', textY: 25,
    },
    2: {
      x: 975, y: 760, sprite: 'car-2', textY: 40,
    },
    3: {
      x: 1180, y: 905, sprite: 'car-1', textY: 40,
    },
  };
  const font = {
    font: '76px Arial',
    fill: 'white',
    stroke: 'orange',
    strokeThickness: 7,
  };
  for (let i = 0; i < 4; i++) {
    const container = this.add.container(answer[i].x, answer[i].y);
    container.init_X = container.x;
    container.init_Y = container.y;
    const car = this.add.sprite(0, 0, answer[i].sprite);
    const asset = this.gameConfig.assets[images[i]];
    const text = this.add.text(-145, answer[i].textY, asset.text, font).setOrigin(0.5);
    container.add(car);
    container.add(text);
    this.carAnimation(container);
    container.txt = asset.text;
    container.setSize(400, 200);
    if (correct.indexOf(asset.id) !== -1) {
      container.isCorrect = true;
      container.correctIndex = correct.indexOf(asset.id);
      this.correctAnswers += 1;
    }
    container.setInteractive();
    this.cursorManager.setDefaultDraggableEvents(container);
    const markAnim = new AnswerMark(this, container).setScale(0.45);
    container.setData('markAnim', markAnim);
    container.on('pointerup', this.checkAnswer.bind(this, container), this);
    this.answers.push(container);
  }
};

RIS.carAnimation = function (car) {
  car.anim = this.tweens.add({
    targets: car,
    x: car.init_X + Math.random() * 3,
    y: car.init_Y + Math.random() * 2,
    duration: 50,
    ease: 'Linear',
    onComplete: this.carAnimation.bind(this, car),
  });
};

RIS.checkAnswer = function (answer) {
  if (answer.isCorrect) {
    this.correctAnswers -= 1;
    this.playCorrect();
    answer.anim.stop();
    answer.disableInteractive();
    answer.getData('markAnim').showMark(true, () => {});
    this.flashAnswer(answer);
    if (this.correctAnswers === 0) {
      this.answers.map((x) => {
        x.disableInteractive();
        x.anim.stop();
      });
      this.time.delayedCall(2000, this.shrinkAnimation, [], this);
    }
  } else {
    answer.getAt(0).setTint(0xff0000);
    answer.getAt(1).setTint(0xff0000);
    answer.anim.stop();
    answer.disableInteractive();
    this.playWrong();
    answer.getData('markAnim').showMark(false, () => {});
  }
};

RIS.shrinkAnimation = function () {
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.answers.map((x) => {
      this.tweens.add({
        targets: x,
        scaleX: '+=0.2',
        scaleY: '+=0.2',
        duration: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
      this.tweens.add({
        targets: x,
        scaleX: 0,
        scaleY: 0,
        duration: 500,
        delay: 300,
        ease: 'Sine.easeInOut',
        yoyo: false,
      });
    });
    this.time.delayedCall(1100, this.nextIteration, [], this);
  }
};

RIS.nextIteration = function () {
  this.answers.map((x) => {
    x.destroy();
  });
  this.answers = [];
  this.question.map((x) => {
    x.destroy();
  });
  this.question = [];
  this.correctAnswers = 0;
  this.loadIteration();
};

RIS.flashAnswer = function (container) {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const questionArray = question.split(' ');
  let index = 0;
  const neededIndex = container.correctIndex;
  for (let i = 0; i < this.question.length; i++) {
    if (questionArray[i] === '_') {
      if (index === neededIndex) {
        this.question[i].setText(container.txt);
        this.flashAnimation(this.question[i]);
      }
      index += 1;
    }
  }
};

RIS.flashAnimation = function (answer) {
  this.tweens.add({
    targets: answer,
    alpha: 0,
    duration: 300,
    ease: 'Linear',
    repeat: 2,
    yoyo: true,
  });
};

RIS.createQuestion = function () {
  const { question } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const sentenceArray = question.split(' ');
  const font = {
    font: '76px Arial',
    fill: 'white',
    stroke: 'orange',
    strokeThickness: 7,
  };
  let x = 630;
  for (let i = 0; i < sentenceArray.length; i++) {
    const word = this.add.text(x, 140, sentenceArray[i], font).setOrigin(0);
    x += word.width + 15;
    this.question.push(word);
  }
};

export default EDC.Games.RacecarImageSelect.Scenes.Main;
